import AppDragDropInput from './AppDragDropFileInput';

export default AppDragDropInput;